import TextWithSubtext from './TextWithSubtext';

export default TextWithSubtext;
